<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("overlay-zoning-plan") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            
            <tbody>
              <tr>
                <td>{{ $t("base-building-lines") }}</td>
                <td>{{ plotItem.OVL_COL }}</td>
              </tr>
              <tr>
                <td>{{ $t("building-lines-cantonal-roads") }}</td>
                <td>{{ plotItem.OVL_CSL }}</td>
              </tr>
              <tr>
                <td>{{ $t("building-lines-national-roads") }}</td>
                <td>{{ plotItem.OVL_NSL }}</td>
              </tr>
              <tr>
                <td>{{ $t("building-lines-forest-distance") }}</td>
                <td>{{ plotItem.OVL_FOL }}</td>
              </tr>
              <tr>
                <td>{{ $t("noise-sensitivity-level") }}</td>
                <td>{{ plotItem.OVL_NOI }}</td>
              </tr>
              <tr>
                <td>{{ $t("water-space-line") }}</td>
                <td>{{ plotItem.OVL_WAL }}</td>
              </tr>
              <tr>
                <td>{{ $t("water-space") }}</td>
                <td>{{ plotItem.OVL_WAA }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem
}
</script>

